import React, { useEffect, useState } from "react";
import { DepoStyle } from "./style";
//import { User } from "phosphor-react";
import CardDepoyments from "./Card";
import FormDepoy from "./Form";
import axios from "axios";

function log(time) {
  var date = new Date(time);
  const showDate = `${date.getDate()}/${date.getMonth()}/${date.getFullYear()}`;
  //const showHours = `${date.getHours()}:${date.getMinutes()}`;
  return (
    <>
      <p>{showDate}</p>
      {/* <p>
        <b>Hora da publicação:</b> {showHours}
    </p> */}
    </>
  );
}

export default function Depoiments() {
  const [depoyments, setDepoyments] = useState([]);

  useEffect(() => {
    axios.get("https://valentin-api.vercel.app/depoyments")
    .then((response) => {
        setDepoyments(response.data)
    }).catch((err) => {
        console.log(err)
    });
  }, [depoyments]);

  return (
    <DepoStyle id="testimonials">
      <div className='card' style={{overflowY: 'auto', height: '50vh', padding: '20px'}}>
        {depoyments.map((depoyment, index) => (
          <CardDepoyments
            id={index}
            name={depoyment.name}
            rating={depoyment.rating}
            avaliation={depoyment.avaliation}
            createdAt={log(depoyment.created_At)}
          />
        ))}
      </div>
      <div className="form">
        <FormDepoy />
      </div>
    </DepoStyle>
  );
}
//<User style={{width: '70px', height: '70px'}}/>
